<template>
  <fieldset>
    <el-divider>Sms Options</el-divider>
    <div class="row mb-30">
      <div class="col-sm-6 checkbox-container">
        <el-checkbox
          id="transactionalSms"
          v-model="modelValue.doNotSendTransactionalSms"
        >
          Do not send me transactions texts
        </el-checkbox>
        <div class="help-block">
          Note that if this option is enabled, the user will not get any driver arriving texts, driver canceled texts, etc!
        </div>
      </div>
    </div>

    <div
      class="row mb-0"
      :class="{ 'disabled-container': modelValue.doNotSendTransactionalSms }"
    >
      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="driverAcceptedRideSms"
          v-model="modelValue.driverAcceptedRideSms"
        >
          Driver Accepted Ride Sms
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="driverCancelledRideSms"
          v-model="modelValue.driverCancelledRideSms"
        >
          Driver Cancelled Ride Sms
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="operatorCancelledRideSms"
          v-model="modelValue.operatorCancelledRideSms"
        >
          Operator Cancelled Ride Sms
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="redispatchedRideSms"
          v-model="modelValue.redispatchedRideSms"
        >
          Redispatched Ride Sms
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="riderCancelledRideSms"
          v-model="modelValue.riderCancelledRideSms"
        >
          Rider Cancelled Ride Sms
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledRideConfirmationSms"
          v-model="modelValue.scheduledRideConfirmationSms"
        >
          Scheduled Ride Confirmation Sms
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledRideSurgeSmsForCaller"
          v-model="modelValue.scheduledRideSurgeSmsForCaller"
        >
          Scheduled Ride Surge Price Confirmation Sms
        </el-checkbox>
      </div>

      <div
        v-if="showNextRideSms"
        class="col-sm-3 checkbox-container"
      >
        <el-checkbox
          id="nextRideSmsOrdering"
          v-model="modelValue.nextRideSmsOrdering"
        >
          Next Ride SMS
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledRideCancelledSms"
          v-model="modelValue.scheduledRideCancelledSms"
        >
          Scheduled Ride Cancelled Sms
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledGroceryConfirmationSms"
          v-model="modelValue.scheduledGroceryConfirmationSms"
        >
          Scheduled Grocery Confirmation Sms
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="deliveryArrivalSms"
          v-model="modelValue.deliveryArrivalSms"
        >
          Delivery Arrival Sms
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="groceryOrderOutsideReminderSms"
          v-model="modelValue.groceryOrderOutsideReminderSms"
        >
          Grocery Order Outside Reminder Sms
        </el-checkbox>
      </div>
    </div>

    <div class="row mt-30 mb-30">
      <div class="col-sm-6 checkbox-container">
        <el-checkbox
          id="doNotSendMarketingSms"
          v-model="modelValue.doNotSendMarketingSms"
        >
          Do not send me marketing texts
        </el-checkbox>
        <div class="help-block">
          Note that if this option is enabled, the user will not get any crm campaign sms!
        </div>
      </div>
    </div>

    <div
      class="row mb-0"
      :class="{ 'disabled-container': modelValue.doNotSendMarketingSms }"
    >
      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmActivationCampaignSms"
          v-model="modelValue.crmActivationCampaignSms"
        >
          CRM Activation Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmActivationHardRegistrationCampaignSms"
          v-model="modelValue.crmActivationHardRegistrationCampaignSms"
        >
          CRM Activation Hard Registration Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmMomentumEngagementCampaignSms"
          v-model="modelValue.crmMomentumEngagementCampaignSms"
        >
          CRM Momentum/Engagement Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmReactivationCampaignSms"
          v-model="modelValue.crmReactivationCampaignSms"
        >
          CRM Reactivation Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmRevivalCampaignSms"
          v-model="modelValue.crmRevivalCampaignSms"
        >
          CRM Revival Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmResurrectionCampaignSms"
          v-model="modelValue.crmResurrectionCampaignSms"
        >
          CRM Resurrection Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmCrossSellGourmetCampaignSms"
          v-model="modelValue.crmCrossSellGourmetCampaignSms"
        >
          CRM Cross Sell Gourmet Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmCrossSellGroceriesCampaignSms"
          v-model="modelValue.crmCrossSellGroceriesCampaignSms"
        >
          CRM Cross Sell Groceries Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmCrossSellHomeServicesCampaignSms"
          v-model="modelValue.crmCrossSellHomeServicesCampaignSms"
        >
          CRM Cross Sell Home Services Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmActivationDormantSoftRegistrationCampaignSms"
          v-model="modelValue.crmActivationDormantSoftRegistrationCampaignSms"
        >
          CRM Activation Dormant Soft Registration Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmActivationDormantHardRegistrationCampaignSms"
          v-model="modelValue.crmActivationDormantHardRegistrationCampaignSms"
        >
          CRM Activation Dormant Hard Registration Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmActivationNewUserAddedCCRegistrationSms"
          v-model="modelValue.crmActivationNewUserAddedCCRegistrationSms"
        >
          CRM Activation New User Added CC Registration Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmActivationNewUserGroceryRegistrationSms"
          v-model="modelValue.crmActivationNewUserGroceryRegistrationSms"
        >
          CRM Activation New User Grocery Registration Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmActivationNewUserGourmetRegistrationSms"
          v-model="modelValue.crmActivationNewUserGourmetRegistrationSms"
        >
          CRM Activation New User Gourmet Registration Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmActivationNewUserOnlineRegistrationSms"
          v-model="modelValue.crmActivationNewUserOnlineRegistrationSms"
        >
          CRM Activation New User Online Registration Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmActivationNewUserPhoneRegistrationSms"
          v-model="modelValue.crmActivationNewUserPhoneRegistrationSms"
        >
          CRM Activation New User Phone Registration Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmActivationNewUserPickedPlanRegistrationSms"
          v-model="modelValue.crmActivationNewUserPickedPlanRegistrationSms"
        >
          CRM Activation New User Picked Plan Registration Campaign
        </el-checkbox>
      </div>
    </div>
  </fieldset>
</template>

<script setup lang="ts">
defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  showNextRideSms: {
    type: Boolean,
    default: true,
  },
});
</script>
